import React, { useEffect, useState } from "react";
import "./loader.css";

const Loader = ({ show, message }) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (show) {
      setOpen(true);
    } else {
      setTimeout(() => {
        setOpen(false);
      }, 500); // Delay for exit animations
    }
  }, [show]);

  return (
    <>
      {open && (
        <div className="overlay">
          <div className="overlay__inner">
            <div className="centercard">
              <div className="loader"></div>
              <p className="message">{message}</p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Loader;
